import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import SearchView from "../../widgets/SearchView";
import Prompt from '../../widgets/Prompt';
import SkillsProgramSetupSearchForm from '../program/SkillsProgramSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'SkillsProgrammeCode', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'SkillsProgrammeTitle', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'ProgrammeStatus', numeric: false, disablePadding: true, label: 'Programme Status' },
    { id: 'SkillsProgrammeRegistrationStartDate', numeric: false, disablePadding: true, label: 'Actual Start Date' },
    { id: 'EndDate', numeric: false, disablePadding: true, label: 'End Date' },
    { id: 'SkillsProgrammeRegistrationEndDate', numeric: false, disablePadding: true, label: 'Completion Date' }
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();

class LearnerBSPSkillsProgramme extends Component {
    constructor(props) {
        super(props);

        console.log(this.props.programmeId);
        this.searchParameters = !utils.isNull(this.props.location.state.learnerID) ? [
            { Name: "SkillsProgrammeID", Value: "" },
            { Name: "SkillsProgramTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "LearnerID", Value: this.props.location.state.learnerID },
            { Name: "BSPType", Value: this.props.location.state.BSPType }
        ]
            :
            [
                { Name: "SkillsProgrammeID", Value: "" },
                { Name: "SkillsProgramTitle", Value: "" },
                { Name: "LearnerID", Value: this.props.location.state.learnerID },
                { Name: "BSPType", Value: this.props.location.state.BSPType }
            ];

        let model = !utils.isNull(this.props.location.state.learnerID) ?
            {
                SkillsProgrammeID: "",
                SkillsProgramTitle: "",
                ProgrammeID: this.props.programmeId,
                LearnerID: this.props.location.state.learnerID,
                BSPType: this.props.location.state.BSPType

            }
            :
            {
                SkillsProgrammeID: "",
                SkillsProgramTitle: "",
                LearnerID: this.props.location.state.learnerID,
                BSPType: this.props.location.state.BSPType
            }


        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }


        this.state = !utils.isNull(this.props.location.state.learnerID) ?
            {
                model: model,
                keyUpSwitch: false,
                toolbarConfig: {
                    items: [
                        {
                            type: "buttonGroup",
                            buttons: [
                                { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                            ]
                        }
                        ,
                        {
                            type: "devider"
                        },
                        {
                            type: "buttonGroup",
                            buttons: [
                                { id: 'view', label: '', tooltip: 'View', icon: 'ViewIcon', visible: this.props.menuPermissionItem.View },
                                { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: (this.props.menuPermissionItem.Add && this.props.location.state.BSPType!=="22") },
                                { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', visible: (this.props.menuPermissionItem.Edit && this.props.location.state.BSPType !== "22"), disabled: true },
                                { id: "delete", label: "", tooltip: "Remove skills programme", icon: "DeleteIcon", visible: (this.props.menuPermissionItem.Delete && this.props.location.state.BSPType !== "22") }
                            ]
                        }
                    ]
                }
            }
            :
            {
                model: model,
                keyUpSwitch: false
            };

        //TODO: Add url for unit standard removal
        this.deleteUrl = ""
    }


    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/learner',
                state: {
                    selection: this.props.location.state.learnerID
                }
            });
        }
        else if (buttonId === "add") {
            this.props.history.push({
                pathname: '/AddLearnerBSPSkillsProgramme',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    SkillsProgrammeID: null,
                    hideFields: true,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    BSPType: this.props.location.state.BSPType,
                    BSPDesc: this.props.location.state.BSPDesc
                }
            })
        }
        else if (buttonId === "edit") {
            this.props.history.push({
                pathname: '/AddLearnerBSPSkillsProgramme',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    SkillsProgrammeID: this.state.selectedLearnerSkillsProgram[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    BSPType: this.props.location.state.BSPType,
                    BSPDesc: this.props.location.state.BSPDesc
                }
            })
        }
        else if (buttonId === "view") {
            this.props.history.push({
                pathname: '/AddLearnerBSPSkillsProgramme',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    SkillsProgrammeID: this.state.selectedLearnerSkillsProgram[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    viewOnly: true,
                    BSPType: this.props.location.state.BSPType,
                    BSPDesc: this.props.location.state.BSPDesc
                }
            })
        }


    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedLearnerSkillsProgram: selection })

            let url = "api/sims/LearnerBSPSkillsProgramme/CheckCanEditProgramme?Id=" + selection[0].Id;
            utils.invokeUrl(url, (response) => {
                toolbarRef.current.setButtonDisabled("edit", response.Result === "0" ? true : false)
            },
                (e) => {
                    toolbarRef.current.setButtonDisabled("edit", true)
                },
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    }
                }
            )
        } else {
            this.setState({ selectedLearnerSkillsProgram: null })
            toolbarRef.current.setButtonDisabled("edit", true)
        }
    }


    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > ${this.props.location.state.BSPDesc} Programmes > ${this.props.location.state.learnerNames}`}
                </p>
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/learnerBSPskillsprogramme/GetLearnerBSPSkillsProgrammeSearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/learnerBSPskillsprogramme/unlinkLearnerBSPSkillsProgramme"} useDeletePost={true}
                    entityViewPath='/AddLearnerBSPSkillsProgramme'
                    model={this.state.model} toolbarConfig={this.state.toolbarConfig}
                    toolbarRef={toolbarRef}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="SkillsProgramTitle" mode={this.props.mode}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                    promptTitle={'Remove Learner Programme'}
                    promptContent={"Are you sure you want to remove the learner Programme record?"}
                >
                    <SkillsProgramSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(LearnerBSPSkillsProgramme));